const DropdownMenu = class DropdownMenu{
    constructor(configDropdownMenu){
        this.dropdownList = configDropdownMenu.dropdownList;
        this.dropdownTrigger = configDropdownMenu.dropdownTrigger;
    }

    init(){
        let trigger,
            allDropdown = this.dropdownList,
            dropdown,
            hoverTimeout,
            navListItem = this.dropdownTrigger;

        this.dropdownTrigger.hover(function () {
            trigger = $(this),
            dropdown = trigger.find(allDropdown);
            
            trigger.removeClass('is-disable');
            trigger.addClass('is-active');
            clearTimeout(hoverTimeout);


            TweenMax.to(allDropdown, 0.2, {
                autoAlpha: 0,
                y: 25,
                ease: Quad.easeOut
            });

            TweenMax.to(dropdown, 0.2, {
                autoAlpha: 1,
                y: 23,
                ease: Quad.easeOut
            });

        }, function () {
            trigger = $(this),
                trigger.removeClass('is-active');

            hoverTimeout = setTimeout(function () {
                TweenMax.to(allDropdown, 0.2, {
                    autoAlpha: 0,
                    y: 25,
                    ease: Quad.easeOut
                });
            }, 100);
        });
    }
}
export {DropdownMenu};


// WEBPACK FOOTER //
// ./static/js/components/DropdownMenu.js